import React from 'react'

import { createSvgIcon } from './utils/create-svg-icon'

export const ProductHouseHeatingIcon = createSvgIcon(
  <>
    <title>product house heating</title>
    <g className="nc-icon-wrapper" fill="#222222">
      <g
        fill="none"
        fillRule="evenodd"
        id="house-heating"
        stroke="none"
        strokeWidth="1"
      >
        <path d="M0 0h32v32H0z" id="Rectangle" />
        <g id="Group" stroke="#222222" transform="translate(1 2)">
          <path
            d="M20.286 13.5h1.071v1.714h-1.071"
            id="Line"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path d="M21.786 14.357h.428" id="Line-2" strokeLinecap="round" />
          <path
            d="M9.571 21H8.5v1.714h1.071"
            id="Line"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path d="M7.643 21.857h.428" id="Line-2" strokeLinecap="round" />
          <rect
            height="12"
            id="Rectangle"
            rx="1.286"
            width="2.571"
            x="9.786"
            y="12"
          />
          <rect
            height="12"
            id="Rectangle-Copy-135"
            rx="1.286"
            width="2.571"
            x="12.357"
            y="12"
          />
          <rect
            height="12"
            id="Rectangle-Copy-136"
            rx="1.286"
            width="2.571"
            x="14.929"
            y="12"
          />
          <rect
            height="12"
            id="Rectangle-Copy-137"
            rx="1.286"
            width="2.571"
            x="17.5"
            y="12"
          />
          <path
            d="M14.318.637L1.402 12.69A.756.756 0 0 0 1.918 14h1.719c.11 0 .2.09.2.2V26a2 2 0 0 0 2 2h18.316a2 2 0 0 0 2-2V14.2c0-.11.09-.2.2-.2h1.723a.758.758 0 0 0 .518-1.313L15.682.637a1 1 0 0 0-1.364 0z"
            id="Shape"
            strokeLinecap="square"
          />
        </g>
      </g>
    </g>
  </>
)
